<template>
  <div class="add-survey">
    <addsurvey />
  </div>
</template>

<script>
import { EventBus } from '@/libs/event-bus'
import Addsurvey from '@/components/user-research/AddSurvey'

export default {
  name: 'AddSurvey',
  components: {
    Addsurvey
  },
  created () {
    EventBus.$emit('onLoading', false)
  }
}
</script>

<style lang="scss" scoped>
.add-survey {
  display: initial !important;
}
</style>
